/**
 * Created by jaime on 10/10/2017.
 */

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { firestoreAction } from 'vuexfire'

export default {
  state: {
    status: null,
    user: null
  },
  mutations: {
    setUser: (state, user) => { state.user = user },
    setStatus: (state, status) => { state.status = status },
  },
  actions: {
    init(context){
      firebase.auth().onAuthStateChanged(function (user) {
          context.commit('setStatus', user)
          if(user) context.dispatch('bindUser', firebase.firestore().collection('users').doc(user.uid))
          else {
            context.dispatch('unbindUser')
            context.commit('setUser', null)
          }
      })
    },
    bindUser: firestoreAction(({ bindFirestoreRef }, ref) => {  bindFirestoreRef('user', ref) }),
    unbindUser: firestoreAction(({ unbindFirestoreRef }) => {  unbindFirestoreRef('user') }),
    auth(context){  return context.state.user   },
    group(context, group) { return context.state.user && context.state.user.groups.indexOf(group) > -1}
  },
  getters: {
    getImage: (state, getters) => state.user,
    getUser: (state, getters) => state.user,
    getStatus: (state, getters) => state.status,
    isGroup:(state, getters) => (group) => state.user && state.user.groups.indexOf(group) > -1,
    isAdmin: (state, getters) =>  state.user && state.user.groups.indexOf('admin') > -1,
    // isSecretaria: (state, getters) => state.user && state.user.groups.indexOf('secretaria') > -1,
    isSecretaria: (state, getters) => state.user && state.user.roles.secretaria,
    isScouter: (state, getters) => state.user && state.user.roles.scouter,
    getUnidad: (state, getters) => state.user.unidad,
    isAuth: (state, getters) =>  state.status || false,

  }
}
